'use client';

import clsx from 'clsx';
import { X } from 'lucide-react';
import { useTranslations } from 'next-intl';
import styles from './Chip.module.scss';

type ChipSize = 'sm' | 'md';

interface ChipProps {
  label: string;
  title?: string;
  size?: ChipSize;
  isActive?: boolean;
  disabled?: boolean;
  removeTitle?: string;
  onClick?: () => void;
  onRemove?: () => void;
}

export const Chip: React.FC<ChipProps> = ({
  label,
  title,
  size = 'md',
  isActive,
  disabled,
  removeTitle,
  onClick,
  onRemove,
}) => {
  const labelId = `chip-label-${label.replace(/\s+/g, '-').toLowerCase()}`;
  const t = useTranslations('components.chip');

  return (
    <div
      className={clsx(styles.chip, {
        [styles.chipSm]: size === 'sm',
        [styles.chipMd]: size === 'md',
        [styles.chipActive]: isActive,
      })}
      role="group"
      aria-labelledby={labelId}
    >
      {onClick ? (
        <button
          type="button"
          onClick={onClick}
          title={title}
          disabled={disabled}
          className={styles.button}
        >
          <span id={labelId}>{label}</span>
        </button>
      ) : (
        <span id={labelId}>{label}</span>
      )}
      {onRemove && (
        <button
          type="button"
          onClick={onRemove}
          disabled={disabled}
          className={styles.removeButton}
        >
          <span className="sr-only">{removeTitle || t('removeLabel', { label })}</span>
          <X aria-hidden="true" />
        </button>
      )}
    </div>
  );
};
